module.exports = __webpack_public_path__ + "img/bottle_incoming.0685b29e.png";